import { dateFormatter, emailToName } from '../../../../helpers/brand-manager-portal-utils';
import style from '../../common-style/common-style.module.css';

export default function PageTopInfo({title, currentDate, nextDate, totalApproved, totalPending, totalRejected, lastUpdate = {}}) {
    // const {accepted, rejected, pending} = counts;
    const lastUpdateItem = Object.keys(lastUpdate).length > 0;
    return (
        <div className={style['title-section']}>
            <h1 id="tableTitle" className={style['main-title']}>{title}</h1>
            <div className={style['title-right']}>
            <ul className={style['status-top']}>
                <li className={style.approved}><span></span> Live ({totalApproved})</li>
                <li className={style.rejected}><span></span> Rejected ({totalRejected})</li>
                <li className={style.pending}><span></span> Pending Review ({totalPending})</li>
            </ul>
            <div className={style['update_date']}>Last auto-generation: {dateFormatter(currentDate)}</div>
            <div className={style['update_date']}>Next auto-generation: {dateFormatter(nextDate)}</div>
            {lastUpdateItem && <div className={style['update_date']}>Last Modified By: <strong title={lastUpdate?.lastModifiedBy}>{emailToName(lastUpdate?.lastModifiedBy)}</strong> on {dateFormatter(lastUpdate?.lastModifiedAt, true)}</div>}
            </div>
        </div>
    )
}